import React from 'react';
import BootstrapModal from 'react-bootstrap/Modal'
import WithFlow from 'conversie-flow-bundle/assets/js/components/flow/WithFlow';

/* Icons */
import CrossIcon from '~/../symbols/cross.svg';

/* Common */
import { Button, Modal } from "~/components/common";

/* Components */
import ConversionFlowSteps from './ConversionFlowSteps';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionFlowModal({
    open,
    handleClose,
    closeText = trans(`app.modal.close`),
    flowUrl,
    modalBody,
}) {
    return (
        <Modal
            open={open}
            handleClose={handleClose}
            closeText={closeText}
            className={'flow__modal'}
            modalContent={
                <WithFlow
                    flowUrl={flowUrl}
                    flow={null}
                    translate={trans}
                >
                    {(passProps) => {
                        const { flow, setStep } = passProps;

                        return (
                            <>
                                <BootstrapModal.Header>
                                    <div className="row gutters-2 justify-content-between align-items-center w-100">
                                        <div className="col-auto">
                                            <p className="text--18 font-weight-bold mb-0">{flow?.flowTitle || trans(`app.modal.loading`)}</p>
                                        </div>
                                        <div className="col-12 col-lg-auto order-1 order-lg-0">
                                            <ConversionFlowSteps
                                                steps={flow?.steps}
                                                setStep={setStep}
                                            />
                                        </div>
                                        <div className="col-auto">
                                            <Button
                                                className="p-0"
                                                theme="none"
                                                showTitle={false}
                                                title={closeText}
                                                showIcon={true}
                                                icon={CrossIcon}
                                                iconSize={14}
                                                iconClassName={'icon--lg-16'}
                                                onClick={handleClose}
                                            />
                                        </div>
                                    </div>
                                </BootstrapModal.Header>
                                <div className="flow__modal-content">
                                    <BootstrapModal.Body>
                                        {modalBody(passProps)}
                                    </BootstrapModal.Body>
                                </div>
                            </>
                        );
                    }}
                </WithFlow>
            }
        />
    )
}
